import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { CircularProgress } from '@mui/material';
import Chart from 'react-apexcharts';
import { fetchOverAllScore as fetchOverAllScoreService } from 'services/modules/idp/company';


const OverallRisk = () => {
  // Redux selector
  const selectedCompanyContainer = useSelector((state) => state.auth.companyData);
  
  // State variables
  const [overallScore, setOverallScore] = useState(0);
  const [loading, setLoading] = useState(true);
  
  const chartOptions = useMemo(() => ({
    chart: {
      height: 250,
      type: 'radialBar',
      offsetY: -10
    },
    plotOptions: {
      radialBar: {
        startAngle: -135,
        endAngle: 135,
        dataLabels: {
          name: {
            fontSize: '16px',
            color: overallScore > 700 ? '#00e676' : 
                   overallScore >= 300 ? '#ffbf00' : '#f44336',
            offsetY: 90
          },
          value: {
            offsetY: 56,
            fontSize: '20px',
            fontWeight: 'bold',
            // Set the color conditionally here
            color: overallScore > 700 ? '#00e676' : 
                   overallScore >= 300 ? '#ffbf00' : '#f44336',
            formatter: () => {
              return `${Math.round(overallScore)}`;

            },
            
          },
          
        },
        track: {
          background: '#d6d7d7'
        }
      }
    },
    fill: {
      type: 'solid',
      colors: [overallScore > 700 ? '#00e676' : 
               overallScore >= 300 ? '#ffbf00' : '#f44336'],
    },
    stroke: {
      dashArray: 4
    },
    labels: [overallScore > 700 ? 'Low' : 
               overallScore >= 300 ? 'Medium' : 'High'],
  }), [overallScore]);

  // Fetch overall score based on company ID
  useEffect(() => {
    if (selectedCompanyContainer) {
      const fetchOverAllScore = async () => {
        const companyId = selectedCompanyContainer.companyid;
        const response = await fetchOverAllScoreService({ params: { company: companyId } });
        const score = response.score ? response.score : 0;
        setOverallScore(score);
        setLoading(false);
      };
      fetchOverAllScore();
    }
  }, [selectedCompanyContainer]);

  return (
    <div className="my-md text-center integrated-dashboard-bg">
      <div>
        <div className="risk-posture-title">Overall Score</div>
      </div>
      <div>
        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '35vh' }}>
            <CircularProgress size={60} />
          </div>
        ) : (
          <>
            <Chart
              options={chartOptions}
              series={[Math.round(overallScore)/10]} // Pass the score as series
              type="radialBar"
              height="300"
            />
            <div className="mx-4 legend">
              <div className="legend-item">
                <span className="legend-color high-risk"></span>
                High risk (0 - 300)
              </div>
              <div className="legend-item">
                <span className="legend-color moderate-risk"></span>
                Moderate risk (301 - 700)
              </div>
              <div className="legend-item">
                <span className="legend-color no-risk"></span>
                Low risk (701 - 1000)
              </div>
            </div>
            {/* <LinearBarWithIndicator value={overallScore}/> */}
          </>
        )}
      </div>
    </div>
  );
};

export default OverallRisk;
